import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;